import axios from 'axios'
import { useMutation } from 'react-query'
import { useAtomValue } from 'jotai'
import { STRIDE_CURRENCY } from '@/config'
import { strideAccountAtom, useUpdateAccountBalances, UpdateAccountBalanceError } from '@/atoms/Wallet'
import { notify } from '@/atoms/Notifications'
import { rollbar } from '@/rollbar'
import { config } from '@/config'

const useRequestTokensMutation = () => {
  const { updateAccountBalances } = useUpdateAccountBalances()

  const strideAccount = useAtomValue(strideAccountAtom)

  const handleMutation = async () => {
    if (!strideAccount) {
      return
    }

    const instance = axios.create({
      baseURL: config.network.faucetApiUrl
    })

    return await instance.get(`/send/${strideAccount.key.bech32Address}`)
  }

  const handleError = (e: Error) => {
    if (e instanceof UpdateAccountBalanceError) {
      notify.error('We could not update your account balance. Please refresh the page.')
    } else {
      notify.error('Requesting of tokens failed.')
    }

    // Faucet has no error reporting so we'll take care of it from here
    rollbar.error(e)
  }

  const handleSuccess = async () => {
    if (!strideAccount) {
      // Wallet has likely been disconnected if strideAccount is non-existent at this point.
      return
    }

    await updateAccountBalances(strideAccount)

    notify.success(`You have received the ${STRIDE_CURRENCY.coinDenom} tokens.`)
  }

  return useMutation(handleMutation, { onSuccess: handleSuccess, onError: handleError })
}

export { useRequestTokensMutation }
